<template>
  <div class="at-entry at-entry--status">
    <aside class="at-entry__visual">
      <span class="at-entry__kite at-entry__kite--a" />
      <span class="at-entry__kite at-entry__kite--b" />
      <svg class="at-entry__emblem" viewBox="0 0 368.86 368.86" aria-hidden="true">
        <path fill="#fffced" d="M102.22,368.27l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21Z"/>
        <path fill="#fffced" d="M.59,102.22l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18L9.79,92.36c-6.03-2.04-11.66,3.98-9.21,9.86Z"/>
        <path fill="#fffced" d="M266.63.59l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21Z"/>
        <path fill="#fffced" d="M368.27,266.63l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18l-89.06-30.18c-6.03-2.04-11.66,3.98-9.21,9.86l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86Z"/>
      </svg>
      <span class="at-entry__vlabel">Cap sur la santé et le bien-être au travail</span>
    </aside>

    <main class="at-entry__panel">
      <div class="at-entry__brand">
        <svg class="at-entry__mark" viewBox="0 0 368.86 368.86" aria-hidden="true">
          <path fill="#1c4d4d" d="M102.22,368.27l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21Z"/>
          <path fill="#1c4d4d" d="M.59,102.22l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18L9.79,92.36c-6.03-2.04-11.66,3.98-9.21,9.86Z"/>
          <path fill="#1c4d4d" d="M266.63.59l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21Z"/>
          <path fill="#1c4d4d" d="M368.27,266.63l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18l-89.06-30.18c-6.03-2.04-11.66,3.98-9.21,9.86l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86Z"/>
        </svg>
        <span class="at-entry__word">Ataviti</span>
        <span class="at-entry__tag">Daisy</span>
      </div>

      <h1 class="at-entry__title at-entry__title--sm">On prépare votre espace</h1>
      <p class="at-entry__lead">Quelques secondes, on charge vos données.</p>
      <div class="at-entry__bar"><span /></div>

      <b-button class="at-entry__loop" variant="link" @click="goToHome()">Ça tourne en boucle ?</b-button>
    </main>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BImg, BSpinner, BButton
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import useUserDroits from '@/auth/useUserDroits'

export default {
  components: {
    BLink,
    BImg,
    BSpinner,
    VuexyLogo,
    BButton
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/under-maintenance.svg'),
    }
  },
  methods: {
    goToHome() {
        this.$router.push({ name: 'presentation' })
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  async created() {
  
    await this.$authService
      .loginCallback()
      .then(async user => {
        
        this.$store.dispatch('user/setMe', {
          displayName: user.profile.given_name,
          userName: user.profile.name,
          email: user.profile.email,
          uid: user.profile.sub
        })

        this.$store.dispatch('user/fetchPreferencesUtilisateur')
        
        const { fetchDroits } = useUserDroits()
        fetchDroits()

        this.$store.dispatch('user/fetchPreferencesUtilisateur').then((response) => {
          var theme = store.state.user.user_preferences.find((value) => value.key == 'theme');
          if (!theme) {
            theme = "light";
            store.commit('appConfig/UPDATE_SKIN', theme);
            this.$store.dispatch('user/saveUserPreference', {
              key: "theme",
              value: "light",
            }).then((value) => {
              console.log("theme preference update");
            })
          } else {
            store.commit('appConfig/UPDATE_SKIN', theme);
          }
        });


        this.$router.push({ name: 'home' })
      })
      .catch(err => {
        console.log('fail', err)
        console.log({err})
        if(err.message.indexOf('No matching state found in storage') >= 0)
          this.$authService.login()

        this.$http.ressifnet.utils.Logger(err.stack, 'error')
      })
  }
}
</script>

<style lang="scss" scoped>
.at-entry {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  grid-template-columns: 0.92fr 1.08fr;
  font-family: 'Figtree', system-ui, -apple-system, sans-serif;
  background: #fffced;
  color: #1c4d4d;
  overflow: hidden;
}
.at-entry__visual {
  position: relative;
  background: #1c4d4d;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.at-entry__kite {
  position: absolute;
  background: #fcf5a6;
  pointer-events: none;
  border-radius: 44% 56% 50% 50% / 56% 46% 54% 44%;
}
.at-entry__kite--a { width: 46vmin; height: 60vmin; left: -12vmin; top: -12vmin; transform: rotate(18deg); opacity: .16; }
.at-entry__kite--b { width: 20vmin; height: 28vmin; right: -4vmin; bottom: 8vmin; transform: rotate(-14deg); opacity: .10; }
.at-entry__emblem {
  width: min(210px, 24vmin);
  height: auto;
  position: relative;
  z-index: 1;
  transform-origin: 50% 50%;
  animation: at-spin 12s linear infinite;
}
.at-entry--status .at-entry__emblem { animation-duration: 4.5s; }
.at-entry__vlabel {
  position: absolute;
  bottom: 28px;
  left: 28px;
  z-index: 1;
  color: rgba(255, 252, 237, .82);
  font-size: .74rem;
  letter-spacing: .12em;
  text-transform: uppercase;
}
.at-entry__panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: clamp(34px, 5vw, 72px);
}
.at-entry__brand { display: flex; align-items: center; gap: 11px; margin-bottom: 8px; }
.at-entry__mark { width: 30px; height: 30px; }
.at-entry__word { font-family: 'Fraunces', Georgia, serif; font-size: 1.45rem; font-weight: 600; color: #1c4d4d; }
.at-entry__tag {
  font-size: .66rem; font-weight: 600; letter-spacing: .14em; text-transform: uppercase;
  color: rgba(28, 77, 77, .6); border-left: 1px solid rgba(28, 77, 77, .4); padding-left: 9px;
}
.at-entry__title {
  font-family: 'Fraunces', Georgia, 'Times New Roman', serif;
  font-weight: 500;
  line-height: 1.05;
  letter-spacing: -.5px;
  margin: 0;
  color: #1c4d4d;
}
.at-entry__title--sm { font-size: clamp(1.9rem, 3.4vw, 2.6rem); }
.at-entry__lead {
  color: rgba(28, 77, 77, .66);
  font-size: 1.06rem;
  line-height: 1.55;
  margin: 0;
  max-width: 42ch;
}
.at-entry__bar {
  width: min(280px, 70%);
  height: 3px;
  border-radius: 3px;
  background: rgba(28, 77, 77, .16);
  overflow: hidden;
  margin-top: 4px;
}
.at-entry__bar > span {
  display: block;
  height: 100%;
  width: 38%;
  border-radius: 3px;
  background: #1c4d4d;
  animation: at-slide 1.5s cubic-bezier(.6, .05, .3, 1) infinite;
}
.at-entry__loop {
  align-self: flex-start;
  margin-top: 4px;
  color: rgba(28, 77, 77, .6) !important;
  font-family: 'Figtree', sans-serif;
  font-weight: 500;
  font-size: .9rem !important;
  text-decoration: none !important;
  padding: 6px 0 !important;
}
.at-entry__loop:hover { color: #1c4d4d !important; }

@keyframes at-spin { to { transform: rotate(360deg); } }
@keyframes at-slide { 0% { transform: translateX(-130%); } 100% { transform: translateX(360%); } }

@media (max-width: 820px) {
  .at-entry { grid-template-columns: 1fr; grid-template-rows: 30% 70%; }
  .at-entry__vlabel { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .at-entry__emblem, .at-entry__bar > span { animation: none; }
}
</style>
